import { Text } from 'bold-ui'

import { NEWS_FONT_SIZE, NewsContentProps } from './news-commons'

export function NewsParagraph(props: Readonly<NewsContentProps>) {
  const { children } = props
  return (
    <Text fontSize={NEWS_FONT_SIZE} component='p'>
      {children}
    </Text>
  )
}
